export default "__VITE_ASSET__CPMmOOr$__"